import { render, staticRenderFns } from "./LecturerManager.vue?vue&type=template&id=7ede8591&"
import script from "./LecturerManager.vue?vue&type=script&lang=js&"
export * from "./LecturerManager.vue?vue&type=script&lang=js&"
import style0 from "./LecturerManager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports